
// taken from http://map-icons.com/, MIT license
export const MapIconCollection: {[key: string]: google.maps.Symbol} = {
    pin: {
        path: "M512.307 910.848c-159.744 0-289.198-127.058-289.198-283.73 0-156.713 289.198-670.638 289.198-670.638s289.219 513.925 289.219 670.638c0 156.672-129.536 283.73-289.219 283.73z",
        scale: 0.04,
        rotation: 180,
        fillColor: '#f5655d',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 1,
        anchor: {x: 500, y: -20} as google.maps.Point,
    },
    pinWithDot: {
        path: "M512 960c-169.656 0-307.2-136.315-307.2-304.456 0-168.161 307.2-719.565 307.2-719.565s307.2 551.404 307.2 719.565c0 168.141-137.544 304.456-307.2 304.456zM510.996 564.49c-52.367 0-94.802 42.086-94.802 93.962 0 51.917 42.435 93.983 94.802 93.983 52.408 0 94.843-42.066 94.843-93.983 0-51.876-42.435-93.962-94.843-93.962z",
        scale: 0.04,
        rotation: 180,
        fillColor: '#f5655d',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 1,
        anchor: {x: 500, y: -20} as google.maps.Point,
    },
    circle: {
        path: "M1003.52 448c0-271.459-220.061-491.52-491.52-491.52s-491.52 220.061-491.52 491.52c0 271.459 220.061 491.52 491.52 491.52s491.52-220.061 491.52-491.52z",
        scale: 0.04,
        rotation: 180,
        fillColor: '#f5655d',
        fillOpacity: .5,
        strokeColor: '#c13b33',
        strokeWeight: 1,
        anchor: {x: 500, y: 500} as google.maps.Point,
    },
    polygonProxy: {
        path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
        fillColor: '#f5655d',
        fillOpacity: 0,
        strokeWeight: 0,
        anchor: {x: 0, y: 0} as google.maps.Point,
    }
};


